import { SVGIcon } from '@/components/atoms/Icon/SVGIcon';
import styled from '@emotion/styled';

export const SearchContainer = styled.div<{ withIcon?: boolean }>`
    display: flex;
    position: relative;
    justify-content: start;
    align-items: center;
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.black200};
    background-color: ${({ theme }) => theme.color.white100};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    width: 250px;

    > div {
        flex: 1;
        background: unset;
    }

    > div > div {
        background-color: unset;
        border: unset !important;
        padding-left: ${({ withIcon }) => (withIcon ? '0' : '16px')};

        input {
            flex: 1;
        }
    }
`;

export const SearchIcon = styled(SVGIcon)`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 12px;
`;
